import React, { Component } from 'react'
import { firebase } from '../../../config/firebase'

class SignOutPage extends Component {

    async componentDidMount() {
        await firebase.auth().signOut()
        this.props.history.replace('/login')
    }

    render() {
        return (
            <div>

            </div>
        )
    }
}

export default SignOutPage



// WEBPACK FOOTER //
// ./src/views/Pages/SignOut/SignOutPage.js